var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdMonitoringFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -660) translate(0 648)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(24 12)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1d6fe0",
    fillRule: "nonzero",
    transform: "translate(24 12) translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", null), /*#__PURE__*/React.createElement("path", {
    d: "M18 4L9 0 0 4v6c0 5.55 3.84 10.74 9 12 2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12c-1.94 1.29-4.58 1.07-6.29-.64-1.95-1.95-1.95-5.12 0-7.07 1.95-1.95 5.12-1.95 7.07 0 1.71 1.71 1.92 4.35.64 6.29l2.9 2.9C17.29 14.69 18 12.38 18 10V4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdMonitoringFilled);
export default __webpack_public_path__ + "static/media/id-monitoring-filled.1ed06977419b7c2d40b3518217a42529.svg";
export { ForwardRef as ReactComponent };